import { getLanguage } from "./dataProvider";
import { BranchModel, ShiftModel } from "./dataStructures";

export interface DropBranchMenuProps {
  onSelectItem: (item: BranchModel) => void;
  selectedItem: BranchModel;
  callback?: (item?: any) => void;
  isDisabled: boolean;
  array_branches: BranchModel[];
}

export interface DropShifthMenuProps {
  onSelectItem: (item: ShiftModel) => void;
  selectedItem: ShiftModel;
  callback?: (item?: any) => void;
  isDisabled: boolean;
  array_shifts: ShiftModel[];
}

export function DropMenuBranchSelection(props: DropBranchMenuProps) {
  const array_items: BranchModel[] = props.array_branches;
  const isEnglish = getLanguage();

  function onSelectItem(item_value: string) {
    const res = array_items.find((x) => x.name === item_value);
    if (res !== undefined) {
      props.onSelectItem(res);
    }
  }

  return (
    <div>
      <label
        htmlFor="location"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {isEnglish ? "Select Branch" : "Filiale auswählen"}
      </label>
      <select
        id="location"
        name="location"
        onChange={(x) => onSelectItem(x.currentTarget.value)}
        disabled={props.isDisabled}
        value={props.selectedItem.name}
        //defaultValue={props.selectedItem.name}
        className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 overflow-auto"
      >
        {array_items.map((x) => CellBranchDropMenu(x))}
      </select>
    </div>
  );
}

function CellBranchDropMenu(item: BranchModel) {
  return <option key={item.branch_id}>{item.name}</option>;
}

export function DropMenuShiftSelection(props: DropShifthMenuProps) {
  const array_items: ShiftModel[] = props.array_shifts;
  const isEnglish = getLanguage();

  function onSelectItem(item_value: string) {
    const res = array_items.find((x) => x.title === item_value);
    if (res !== undefined) {
      props.onSelectItem(res);
    }
  }
  return (
    <div>
      <label
        htmlFor="location"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {isEnglish ? "Select Shift" : "Schicht auswählen"}
      </label>
      <select
        id="location"
        name="location"
        onChange={(x) => onSelectItem(x.currentTarget.value)}
        disabled={props.isDisabled}
        defaultValue={
          props.selectedItem !== undefined
            ? (props.selectedItem as ShiftModel).title
            : array_items[0].title
        }
        className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 overflow-auto"
      >
        {array_items.map((x) => CellShiftDropMenu(x))}
      </select>
    </div>
  );
}

function CellShiftDropMenu(item: ShiftModel) {
  return <option key={item.shift_id}>{item.title}</option>;
}
